<div class="home-section-heading">
  <div>
    <p class="home-section-heading__eyebrow">{{ eyebrow() }}</p>
    <h2 [id]="headingId()">{{ title() }}</h2>
  </div>

  @if (showViewAll()) {
    <button type="button" (click)="viewAll.emit()">
      Ver todo
      <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
    </button>
  }
</div>
